const clearWhitespace = (text) => {
  return text.replace(/(^\s+)|(\s+$)/, "")
}

const isEndWithQuestionMark = (text) => {
  return Boolean(text.match(/^.+\?$/))
}

export {
  clearWhitespace,
  isEndWithQuestionMark
}